import { Card, CardContent, CardHeader, Skeleton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AvatarSkeleton from '../../../avatar/AvatarSkeleton';

const CardFeedLoading = () => {
  return (
    <Card>
      <CardHeader
        avatar={
          <AvatarSkeleton
            size='dashboard'
            variant='circular'
          />
        }
        
        title={<Skeleton width={120} height={24} />}
        subheader={
          <div className='flex flex-col gap-1 '>
            <div className='flex gap-1'>
                <Skeleton width={80} height={20} />
            </div>
            <Typography variant='caption' color='textSecondary'>
                <Skeleton width={100} height={16} />
            </Typography>
          </div>
        }
        classes={{
          title: 'text-lg font-bold',
          subheader: 'flex space-x-1'
        }}
      />
      <CardContent>
        <Typography variant='h5' gutterBottom>
          <Skeleton width={200} height={28} />
        </Typography>
        <div className='my-4'>
            <Skeleton variant='rectangular' width='100%' height={118} />
        </div>
      </CardContent>
    </Card>
  );
};

export default CardFeedLoading;
